const MauritiusSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111866)">
      <path
        d="M2.43164 10.4348L19.9998 12.1739L37.568 10.4348C34.1759 4.21789 27.5807 0 19.9998 0C12.419 0 5.82375 4.21789 2.43164 10.4348Z"
        fill="#D80027"
      />
      <path
        d="M2.4318 29.5641L20 31.3033L37.5682 29.5641C39.1185 26.7227 40 23.4637 40 19.9989L20 18.2598L0 19.9989C0 23.4637 0.881484 26.7227 2.4318 29.5641Z"
        fill="#FFDA44"
      />
      <path
        d="M2.4318 10.4346C0.881484 13.2761 0 16.535 0 19.9998H40C40 16.535 39.1185 13.2761 37.5682 10.4346H20H2.4318Z"
        fill="#0052B4"
      />
      <path
        d="M19.9998 40.0002C27.5807 40.0002 34.1759 35.7823 37.568 29.5654H2.43164C5.82375 35.7823 12.419 40.0002 19.9998 40.0002Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111866">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default MauritiusSvg;
